// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1j868","button_light":"Button_button_light__2zdxt","button_active":"Button_button_active__2veo1"};